'use strict';

/**
 * @name env
 */

exports.getPageEnv = require('./get-page-env.js');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/env/index.js
// module id = 576
// module chunks = 0